import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import ProductCard from "./ProductCard";
import ProductDetailPopup from "../components/ProductDetailPopup";
import products from "../pages/products";
import "../styles/productPage.css";
import { useLocation } from "react-router-dom";

export default function ProductPage() {
  const location = useLocation();
  
  // Get all unique categories from products
  const allCategories = ["All", ...new Set(products.map(p => p.category))];
  
  // Initialize selectedCategory from location state or default to "All"
  const [selectedCategory, setSelectedCategory] = useState(() => {
    // Check if category was passed via navigation state
    if (location.state && location.state.category) {
      return location.state.category;
    }
    return "All";
  });
  
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Update selectedCategory when location state changes
  useEffect(() => {
    if (location.state && location.state.category) {
      setSelectedCategory(location.state.category);
    }
  }, [location.state]);

  let filteredProducts = products.filter((p) =>
    selectedCategory === "All" ? true : p.category === selectedCategory,
  );

  if (search) {
    filteredProducts = filteredProducts.filter((p) =>
      p.name.toLowerCase().includes(search.toLowerCase()),
    );
  }

  if (sort === "low") {
    filteredProducts.sort((a, b) => a.price - b.price);
  } else if (sort === "high") {
    filteredProducts.sort((a, b) => b.price - a.price);
  }

  const handleViewClick = (productId) => {
    const product = products.find(p => p.id === productId);
    setSelectedProduct(product);
  };

  const handleClosePopup = () => {
    setSelectedProduct(null);
  };
  

  return (
    <div className="container-fluid product-page py-3">
      <div className="row">
        {/* Sidebar */}
        <div className="col-lg-3 col-md-4 sidebar-wrapper">
          <h5 className="mb-2 d-none d-md-block">Categories</h5>
          <Sidebar
            categories={allCategories}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
        </div>

        {/* Products */}
        <div className="col-lg-9 col-md-8 product-content">
          {/* Page Title */}
          <div className="row mb-4">
            <div className="col-12">
              <h3 className="page-title">
                {selectedCategory === "All" ? "All Products" : selectedCategory}
              </h3>
              <p className="text-muted">
                Showing {filteredProducts.length} product{filteredProducts.length !== 1 ? 's' : ''}
                {selectedCategory !== "All" && ` in ${selectedCategory}`}
              </p>
            </div>
          </div>

          {/* Filters */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6 col-sm-12 mb-2 mb-md-0">
              <input
                type="text"
                className="form-control"
                placeholder="Search products..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Product Grid */}
          <div className="row">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <ProductCard 
                  key={product.id} 
                  product={product}
                  onViewClick={handleViewClick}
                />
              ))
            ) : (
              <div className="col-12">
                <p className="text-center text-muted">No products found.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Product Detail Popup */}
      {selectedProduct && (
        <ProductDetailPopup
          product={selectedProduct}
          onClose={handleClosePopup}
        />
      )}
    </div>
  );
}